import React, {
  useState, useEffect, useRef
} from 'react'
// eslint-disable-next-line import/no-unresolved
import {
  Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap'
import cookey from 'react-cookies'
import {
  Button
} from '@mui/material'
import boardService from '../../services/api/boardService'
import loginService from '../../services/api/loginService'
import moment from 'moment'

function IdleMonitor ({
  idleTimeout1
}) {
  // Modal
  const [idleModal, setIdleModal] = useState(false)
  const [idleLogout, setIdleLogout] = React.useState(70000) 
  const isModalOpenRef = useRef(false)
  // console.log(`ooo ${idleTimeout1}`)
  const idleTimeout = idleTimeout1 || 900000 
  // const idleLogout = 500 * 60 * 2 // 2 Minutes
  let idleEvent
  let idleLogoutEvent

  /**
   * Add any other events listeners here
   */
  const events = [
    'mousemove',
    'click',
    'keypress',
    'dblclick',
    'scroll'
  ]

  /**
   * @method sessionTimeout
   * This function is called with each event listener to set a timeout or clear a timeout.
   */
  const sessionTimeout = () => {
    if (idleEvent) clearTimeout(idleEvent)
    if (idleLogoutEvent) clearTimeout(idleLogoutEvent)

    idleEvent = setTimeout(() => setIdleModal(true), idleTimeout) // show session warning modal.
    // idleLogoutEvent = setTimeout(() => logOut, idleLogout) // Call logged out on session expire.
  }

  /**
   *
   *
   */
  const getSecondsToDisplay = () => {
    // console.log(`idle log out ${idleLogout}`)
    if (idleLogout / 1000 > 0) {
      setTimeout(() => setIdleLogout(idleLogout - 1000), 1000)
    } else {
      // console.log(`idle log out less than  ${idleLogout}`)
      // window.location.reload(false)
    }
  }
  /**
   * @method buttonOnlickFunction
   * This function will extend current user session.
   */
  const buttonOnlickFunction = (button) => {
    if (button === 'Resume JJ Kanban') {
      const userN = cookey.load('username')
      if (userN) {
        const sessionEnding = localStorage.getItem(`${userN.toString().toLowerCase()}_session_end`)
        const timeDiff = Math.trunc(new Date(sessionEnding).getTime() / 1000) - Math.trunc(new Date().getTime() / 1000)
        // console.log("time Diff=============>", timeDiff, new Date(sessionEnding).getTime()) 
        if (timeDiff > 70) {
          setIdleModal(false)
          setIdleLogout(null)
          setTimeout(() => setIdleLogout(70000), 1000)
          return
        }
      }
      window.location.reload(false)
    } else if (button === 'Extend Session') {
      const userN = cookey.load('username').toString().toLowerCase()
        boardService.checkAdmin(cookey.load('username')).then((adminresponse) => {
          loginService.sessionexists().then((response) => {
            localStorage.setItem(`${userN}_session_end`,
              response.data.session_end)
          })
        })
        setIdleLogout(null)
        setTimeout(() => setIdleLogout(70000), 1000)
        setIdleModal(false)
      // eslint-disable-next-line no-console
      // console.log('user wants to stay logged in', idleLogout)
    }
  }

  const closeButton = () => {
    setIdleModal(false)
    if (idleLogout === 0) {
      setTimeout(() => setIdleLogout(70000), 1000)
      window.location.reload(false)
    } else {
      const userN = cookey.load('username').toString().toLowerCase()
      boardService.checkAdmin(cookey.load('username')).then((adminresponse) => {
        loginService.sessionexists().then((response) => {
          localStorage.setItem(`${userN}_session_end`,
            response.data.session_end)
        })
      })
      setIdleLogout(null)
      setTimeout(() => setIdleLogout(70000), 1000)
      setIdleModal(false)
    }
  }

  /**
   * @method logOut
   * This function will destroy current user session.
   */
  // const logOut = () => {
  //   // eslint-disable-next-line no-console
  //   console.log('logging out')
  // }

  // Keep ref in sync so resetSessionEnd can check modal state inside closure
  useEffect(() => {
    isModalOpenRef.current = idleModal
  }, [idleModal])

  useEffect(() => {
    const sessionDuration = (idleTimeout1 || 900000) + 70000

    const resetSessionEnd = () => {
     
      if (isModalOpenRef.current) return
      const userN = cookey.load('username')
      if (userN) {
        localStorage.setItem(
          `${userN.toString().toLowerCase()}_session_end`,
          new Date(Date.now() + sessionDuration).toISOString()
        )
      }
    }

    for (const e in events) {
      window.addEventListener(events[e], resetSessionEnd)
    }

    const interval = setInterval(() => {
      // setSeconds(seconds => seconds + 1);

      let currentTime = new Date().getTime() / 1000
      const warningTime = 0
      const userN = cookey.load('username').toString().toLowerCase()
      const sessionEnding = localStorage.getItem(`${userN}_session_end`)
      let sessionEnd = new Date(sessionEnding).getTime() / 1000
      sessionEnd = Math.trunc(sessionEnd)
      currentTime = Math.trunc(currentTime)
      const timeDiff = sessionEnd - currentTime
      if (timeDiff <= 70 && timeDiff > 0) {
        setIdleModal(true)
      } else if (timeDiff < 0) {
        // window.location.reload(false)
      } else {
        // console.log(`Session Check. Session Will end at - ${sessionEnd}`)
      }
    }, 5000)

    return () => {
      clearInterval(interval)
      for (const e in events) {
        window.removeEventListener(events[e], resetSessionEnd)
      }
    }
  }, [])

  return (

    <Modal
      isOpen={idleModal}
      toggle={closeButton}
      backdrop={false}
      zIndex='10500'
    >
      <ModalHeader toggle={closeButton}>
        {idleLogout > 0 ? 'Session expiration warning' : 'Session Expired'}
      </ModalHeader>
      {idleLogout > 0
        ? (
          <ModalBody>
            Your session will expire in
            {' '}
            {idleModal ? getSecondsToDisplay() : null}
            {idleLogout / 1000}
            {' '}
            seconds. Do you want to extend the session?
          </ModalBody>
        )
        : <ModalBody>To continue using JJ Kanban, click the button below</ModalBody>}
      <ModalFooter>
        {/* <button className='btn btn-info' onClick={() => logOut()}>Logout</button> */}
        {idleLogout > 0
          ? (
            <Button
              variant='contained'
              color='primary'
              onClick={() => buttonOnlickFunction('Extend Session')}
            >
              Extend Session
            </Button>
          )
          : (
            <Button
              variant='contained'
              color='primary'
              onClick={() => buttonOnlickFunction('Resume JJ Kanban')}
            >
              Resume JJ Kanban
            </Button>
          )}
      </ModalFooter>
    </Modal>
  )
}

export default IdleMonitor
